import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Button } from 'gd-design-library';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import styles from './ScrollToTopFab.module.scss';

const CN = 'scroll-to-top-fab';
const fabClassName = `${CN}__fab`;

const cx = classNames.bind(styles);

interface Position {
  top?: string | number;
  bottom?: string | number;
  left?: string | number;
  right?: string | number;
}

interface ScrollToTopFabProps {
  className?: string;
  threshold?: number;
  position?: Position;
}

export const ScrollToTopFab: React.FC<ScrollToTopFabProps> = ({
  className,
  threshold = 400,
  position = { bottom: '1rem', right: '1rem' }
}) => {
  const [ isVisible, setIsVisible ] = useState(false);

  useEffect(() => {
    const handleScroll = (): void => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrollTop > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return (): void => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ threshold ]);

  const scrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      isIcon
      variant='primary'
      onClick={ scrollToTop }
      className={ cx(fabClassName, className) }
      style={ position }
      aria-label='Scroll to top'
    >
      <KeyboardArrowUpIcon />
    </Button>
  );
};
